<template>
	<div>
   	<!-- <page-title-bar></page-title-bar> -->
       <loader :show="enviando"/>
        <v-container fluid>
            <v-layout row wrap>
                <v-flex xs12 md12>
                    <v-card class="elevation-10">
                        <v-toolbar >
                            <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
                            <v-card-title><h3>Listado de puestos</h3></v-card-title>
                        </v-toolbar>

                        <v-card-title primary-title>
                            
                            <v-card>
                                <v-card-title>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="buscar"
                                        append-icon="search"
                                        label="Search"
                                        single-line
                                        hide-details
                                    ></v-text-field>
                                </v-card-title>


                                <v-data-table
                                    :headers="lista.headers"
                                    :items="lista.data"
                                    :rows-per-page-items="tableProps.rows"
                                    :no-data-text="tableProps.noData"
                                    :no-results-text="tableProps.noResults"
                                    :rows-per-page-text="tableProps.rowsText"
                                    class="elevation-1"
                                    :search="buscar"
                                >
                                    <template slot="items" slot-scope="props">
                                        <td>
                                            <v-menu v-if="puedeModificar || puedeEliminar"
                                                transition="scale-transition"
                                                origin="left top"
                                                bottom
                                                right
                                                slot="activator"
                                            >
                                                <v-btn class="ma-0" icon slot="activator">
                                                    <v-icon>more_vert</v-icon>
                                                </v-btn>
                                                <v-list class="app-card-action">
                                                    <v-list-tile 
                                                        v-if="puedeModificar"
                                                        @click="modificaDialog(props.item._id,props.item.nombre)">
                                                        <i class="fa fa-edit blue--text mr-2 fs-14"></i>
                                                        <span>Modificar</span>
                                                    </v-list-tile>
                                                    <v-list-tile v-if="puedeEliminar" @click="eliminar._id=props.item._id;eliminar.mostrar=true">
                                                        <i class="fa fa-times red--text mr-2 fs-14"></i>
                                                        <span>Eliminar puesto</span>
                                                    </v-list-tile>
                                                </v-list>
                                            </v-menu>

                                        </td>
                                        <td class="text-xs-left">{{ props.item.nombre }}</td>
                                    </template>
                                </v-data-table>
                            </v-card>
													
                        </v-card-title>

                        <v-card-title v-if="puedeAgregar">
                            <v-tooltip top>
                                <v-btn fab dark small color="primary" slot="activator" @click="agregar=true">
                                    <v-icon dark>fa-user-plus</v-icon>
                                </v-btn>
                                <span>Agregar</span>
                            </v-tooltip>
                        </v-card-title>

                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <agregar-puesto
            v-if="agregar"
            :mostrar="agregar"
            @cancelarAgregar="agregar=false"
            @puestoAgregado="nuevoPuesto"
            @enviandoStart="enviando=true"
            @enviandoStop="enviando=false"
        />
        <modificar-puesto
            v-if="modificar.mostrar"
            :puesto="modificar"
            @cancelarModificar="modificar.mostrar=false"
            @puestoModificado="puestoModificado"
            @enviandoStart="enviando=true"
            @enviandoStop="enviando=false"
        />

        <!-- DIALOG PARA ELIMINAR PUESTO -->
        <v-dialog v-model="eliminar.mostrar" persistent max-width="310">
            <v-card>
                <v-card-title class="headline">Zona protegida</v-card-title>
                <v-card-text>
                    <p>Esta acción requiere ingresar su contraseña.</p>
                    <v-text-field label="Contraseña" name="resetPassTF" v-model="eliminar.password" type="password"></v-text-field>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat @click="eliminar.mostrar=false">Cancelar</v-btn>
                <v-btn color="primary" @click="eliminarPuesto()">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

	</div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from '../../components/Loader'
import AgregarPuesto from './agregar'
import ModificarPuesto from './modificar'
import axios from 'axios'
import moment from 'moment'

export default {
	name: 'Puestos',
	components: {
        Loader,
        AgregarPuesto,
        ModificarPuesto
	},
  computed: {
    ...mapGetters([
        "sessionToken",
        "httpURL",
        "userId",
        "tableProps",
        "role",
        "permisos"
      ]),
    puedeAgregar(){
        return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 169) >= 0 ? true : false;
    },
    puedeModificar(){
        return ( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 170) >= 0 ) ? true : false;
    },
    puedeEliminar(){
        return ( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 171) >= 0 ) ? true : false;
    },
  },
    data() {
        return {
            enviando:false,
            buscar:'',
			lista:{
				headers:[
                    { text: '', value: 'Options', sortable: false },
                    { text: 'Nombre', value: 'nombre' }
                ],
                data:[]
            },
            agregar: false,
            modificar:{
                mostrar: false,
                _id: null,
                nombre: null
            },
            eliminar:{
                mostrar: false,
                _id: null,
                password: null    
            }
        }
	},
    created(){
        axios.get(this.httpURL+'/puestos/listado',{headers:{token: this.sessionToken}})
            .then(res => {
                this.lista.data = res.data.puestos;
                this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
                // console.log(error);
                this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
            });
    },
  
	methods: {
		nuevoPuesto(puesto){
            this.lista.data.push(puesto);
            this.agregar = false;            
        },
        modificaDialog(id,nombre){
            this.modificar._id = id;
            this.modificar.nombre = nombre;
            this.modificar.mostrar = true;
        },
        puestoModificado(puesto){
            // console.log(puesto);
            let index = this.lista.data.findIndex(x=> x._id == puesto._id);
            this.lista.data.splice(index,1,puesto);
        },
        eliminarPuesto(){
            axios.delete(this.httpURL+'/puestos/eliminar/', 
                {data:{password:this.eliminar.password,id:this.eliminar._id}, 
                headers:{token: this.sessionToken}
                })
                .then(res => {
                    //console.log(res);
                    let index = this.lista.data.findIndex(x=>x._id == this.eliminar._id);
                    this.lista.data.splice(index,1);
                    this.eliminar._id = null;
                    this.eliminar.password = null;
                    this.eliminar.mostrar = false;
                    
                    this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                })
                .catch(error => {
                    if(error.response){
                        //console.log(error.response);
                        this.$notify({
                            group: 'foo_notif', type:'error darken-2', duration:4000,text: error.response.data.mensaje
                        });
                    }else{
                        //console.log(error);
                        this.$notify({
                            group: 'foo_notif', type:'error darken-2', duration:3500, title: 'Error de conexión', text: 'No se pudo establecer comunicación con el servidor.'
                        });
                    }
                    this.enviando = false;
                }); 
        }
	}
};
</script>

<style>
    .alert-style{
        font-family: 'Heebo', sans-serif !important;
    }
</style>